import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProjectInfoState {
  data: any | null;
}

const initialState: ProjectInfoState = {
  data: null,
};

const projectInfoSlice = createSlice({
  name: "projectInfo",
  initialState,
  reducers: {
    setProjectInfo: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
    },
    clearProjectInfo: (state) => {
      state.data = null;
    },
  },
});

export const { setProjectInfo, clearProjectInfo } = projectInfoSlice.actions;
export default projectInfoSlice.reducer;
